import { READING_BODY_CLASS } from './RadarMetaView';
import { RedactionAwareText } from './RedactionAwareText';

export const SourceView = ({ source }) => {
  if (!source?.full_text) {
    return (
      <p className="text-ink-55">No text has been read from this copy yet.</p>
    );
  }

  return (
    <RedactionAwareText
      as="div"
      className={READING_BODY_CLASS}
      text={source.full_text}
      testId={`source-view-${source.document_id}`}
      testIdPrefix={`source-view-${source.document_id}`}
    />
  );
};

export default SourceView;
